import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractorsDocsComponent } from './contractors-docs/contractors-docs.component';
import { ContractorsEmployeesComponent } from './contractors-employees/contractors-employees.component';
import { ContractorsPrequalificationsEditComponent } from './contractors-prequalifications/contractors-prequalifications-edit/contractors-prequalifications-edit.component';
import { ContractorsPrequalificationsComponent } from './contractors-prequalifications/contractors-prequalifications/contractors-prequalifications.component';
import { ContractorsSitesComponent } from './contractors-sites/contractors-sites.component';
import { ContractorsLayoutComponent } from './contractors-layout/contractors-layout.component';
import { ContractorsComponent } from './contractors/contractors/contractors.component';
import { ContractorsItemsViewComponent } from './contractors-prequalifications/contractors-items/contractors-items-view/contractors-items-view.component';
import { AuthGuard } from '../guards/auth.guard';
import { RBACGuard } from '../guards/rbac.guard';
import { RBACService } from '../shared/rbac.service';
import { PlanGuard } from '../guards/plan.guard';
import { AppService } from '../app.service';
import { ContractorsRelatedAccountsComponent } from './contractors-related-accounts/contractors-related-accounts.component';
import { ContractorsDetailsComponent } from './contractors/contractors-details/contractors-details.component';
import {ContractorsImporterComponent} from "./contractors-importer/contractors-importer.component";
import {ContractorsSubcontractorsComponent} from "./contractors-subcontractors/contractors-subcontractors.component";

const routes: Routes = [
  {
    path: 'contractors',
    component: ContractorsComponent,
    canActivate: [
      AuthGuard
    ]
  },
  {
    path: 'contractors/importer',
    component: ContractorsImporterComponent,
    canActivate: [
      AuthGuard,
      RBACGuard
    ],
    data: {
      permissions: [
        RBACService.getPermission(RBACService.RBAC_F.F_CONTRACTORS, RBACService.RBAC_A.A_CREATE)
      ],
      exact: true
    }
  },
  {
    path: 'contractors/:contractor_id',
    component: ContractorsLayoutComponent,
    canActivate: [
      AuthGuard
    ],
    children: [
      {
        pathMatch: 'full', path: '', redirectTo: 'details'
      },
      { path: 'details', component: ContractorsDetailsComponent },
      { path: 'contractors', component: ContractorsSubcontractorsComponent },
      { path: 'employees', component: ContractorsEmployeesComponent },
      { path: 'related-accounts', component: ContractorsRelatedAccountsComponent },
      // Contractor Sites (Sub-Safety Plans) is part of the Premium SAFETY_PLANS feature area.
      { path: 'sites', component: ContractorsSitesComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.SAFETY_PLANS } },
      // Contractor company documents are a Premium DOCUMENTS surface.
      { path: 'docs', component: ContractorsDocsComponent, canActivate: [PlanGuard], data: { planFeature: AppService.FEATURES.DOCUMENTS } },
      {
        path: 'prequalifications',
        component: ContractorsPrequalificationsComponent,
        canActivate: [PlanGuard],
        data: { planFeature: AppService.FEATURES.PRE_QUALIFICATIONS }
      },
      {
        path: 'prequalifications/:prequal_id/edit',
        component: ContractorsPrequalificationsEditComponent,
        canActivate: [PlanGuard],
        data: { planFeature: AppService.FEATURES.PRE_QUALIFICATIONS }
      },
      {
        path: 'prequalifications/items/:pivot_id/view',
        component: ContractorsItemsViewComponent,
        canActivate: [PlanGuard],
        data: { planFeature: AppService.FEATURES.PRE_QUALIFICATIONS }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContractorsRoutingModule {}
